<div [attr.data-qa]="qaTag() + '-wrapper'" class="autocomplete-wrapper">
    <app-text-input (blurred)="onInputBlur()"
                    (focused)="onInputFocus()"
                    (keydown)="onKeyDown($event)"
                    (ngModelChange)="onTextInputChange($event)"
                    [disabled]="isDisabled()"
                    [hasClearButton]="hasClearButton()"
                    [inputId]="id()"
                    [maxInputLength]="maxInputLength()"
                    [minInputLength]="minInputLength()"
                    [ngModelOptions]="{standalone: true}" [ngModel]="inputValue()">
        @if (prefixIconUrl()) {
            <app-icon [iconUrl]="{url: prefixIconUrl()|authImage:{loadingElementSelf: true}, fallback: prefixIconFallback() }"
                      appContentPrefix aria-hidden="true" class="autocomplete-option-icon"/>
        } @else if (prefixIconFallback()) {
            <app-icon class="autocomplete-option-icon" appContentPrefix aria-hidden="true" [svgIcon]="prefixIconFallback()" />
        }
    </app-text-input>
    @if (isOpen() && !isLoading() && suggestions().length > 0) {
        <ul [attr.data-qa]="qaTag() + '-dropdown'" class="autocomplete-dropdown">
            @for (suggestion of suggestions(); track suggestion; let i = $index) {
                <li [attr.data-qa]="qaTag() + '-option-item'" [class.is-active]="i === activeIndex()" class="autocomplete-option">
                    <button (pointerdown)="onOptionPointerDown($event)"
                            (pointerup)="onOptionPointerUp($event, suggestion.text)"
                            [attr.data-qa]="qaTag() + '-option'"
                            class="autocomplete-option-button"
                            type="button">
                        @if (suggestion.icon || suggestion.iconUrl) {
                            <app-icon [iconUrl]="{url: suggestion.iconUrl|apiVaultIconUrl|authImage:{loadingElementSelf: true}, fallback: suggestion.fallbackIcon }"
                                      [qaTag]="qaTag() + '-option-icon'"
                                      [svgIcon]="suggestion.icon"
                                      aria-hidden="true"
                                      class="autocomplete-option-icon"/>
                        }
                        {{ suggestion.text }}
                    </button>
                </li>
            }
        </ul>
    }
</div>
